var _path, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterTopShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1366,
    height: 82,
    viewBox: "0 0 1366 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M376 20.4998C238.5 1.49988 192.5 -8.00008 0 12.3618V81.9999H1366V8.58853C1284.26 43.2829 1075.5 71.4407 921.245 71.4407C717 71.4407 510.841 39.1325 376 20.4998Z",
    fill: "url(#paint0_linear_79_9)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_9",
    x1: 0,
    y1: 82,
    x2: 1366,
    y2: 81.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31365E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#068192"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTopShape);
export default __webpack_public_path__ + "static/media/footer-top-shape.6cb2e3a1996b96110030a67fffee1740.svg";
export { ForwardRef as ReactComponent };